module.exports = __webpack_public_path__ + "img/pro-zdPc.45b914d5.png";